export default "__VITE_ASSET__D0Oivj4m__"